module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-bg-video"
  }, [_vm._m(0), _c('div', {
    staticClass: "custom-bg-video__title-box"
  }, [_c('div', {
    staticClass: "custom-bg-video__title"
  }, [_c('h1', {
    staticClass: "hero"
  }, [_vm._v(_vm._s(_vm.props.hero.title))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-bg-video__container"
  }, [_c('div', {
    staticClass: "custom-bg-video__hero",
    staticStyle: {
      "background-image": "url('/static/hero-home.jpg')"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c345842","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-bg-video/custom-bg-video.pug
// module id = 578
// module chunks = 1